module.exports = __webpack_public_path__ + "img/picture_logo1.077cb701.jpg";